<div class="container mx-auto px-0 py-0">
  <div class="bg-white shadow-md rounded-lg p-6">
    
    <!-- Header -->
    <div class="flex justify-between items-center mb-6">
      <div class="flex items-center space-x-2">
        <h2 class="text-2xl font-bold mb-0 text-blue-600">
          📅 {{ 'STATUS_VIEW.GEPLANT_TITLE' | translate }}
        </h2>
      </div>
    </div>

    <!-- Status Description -->
    <div class="mb-6 p-4 bg-blue-50 border-l-4 border-blue-400 rounded">
      <div class="flex">
        <div class="flex-shrink-0">
          <mat-icon class="text-blue-400">schedule</mat-icon>
        </div>
        <div class="ml-3">
          <p class="text-sm text-blue-700">
            {{ 'STATUS_VIEW.GEPLANT_MSG' | translate }}
          </p>
        </div>
      </div>
    </div>

    <!-- Header Info Section -->
    <app-header-info 
      [kontrolltermin]="kontrolltermin" 
      [editableFields]="[]"
      [showTimeFields]="true"
      [sourceStatus]="'geplant'"
      (batchFieldsChanged)="onHeaderBatchChanged($event)">
    </app-header-info>

    <app-techniker-infos [standort]="kontrolltermin.standort"></app-techniker-infos>

    <!-- Loading State -->
    <div *ngIf="isLoading" class="flex justify-center items-center py-8">
      <mat-progress-spinner color="primary" mode="indeterminate"></mat-progress-spinner>
      <span class="ml-4 text-gray-600">{{ 'STATUS_VIEW.LOADING_TECHNICIANS' | translate }}</span>
    </div>

    <!-- Content -->
    <div *ngIf="!isLoading" class="space-y-4">

    </div>

    <!-- Actions Section -->
    <div class="flex justify-between items-center pt-6 border-t border-gray-200">
      <!-- Delete button on the left -->
      <button 
        (click)="onDelete()" 
        mat-button
        color="warn"
        class="text-red-600 hover:text-red-800 hover:bg-red-50">
        <mat-icon class="mr-2 w-5 h-5">delete</mat-icon>
        {{ 'COMMON.DELETE' | translate }}
      </button>
      
      <!-- Other actions on the right -->
      <div class="flex space-x-4">
        <button 
          (click)="onCancel()" 
          mat-button>
          {{ 'APPOINTMENT_EDIT.ABORT' | translate }}
        </button>
        
        <button 
          (click)="onSave()" 
          [disabled]="!selectedTechnikerId || isSaving" 
          mat-raised-button 
          color="primary">
          <span *ngIf="isSaving">{{ 'APPOINTMENT_EDIT.SAVING' | translate }}</span>
          <span *ngIf="!isSaving">{{ 'COMMON.SAVE' | translate }}</span>
        </button>
        
        <button 
          (click)="activateKontrolltermin()" 
          [disabled]="!selectedTechnikerId || isSaving" 
          mat-raised-button 
          color="accent">
          <span *ngIf="isSaving">{{ 'STATUS_VIEW.ACTIVATING' | translate }}</span>
          <span *ngIf="!isSaving">{{ 'STATUS_VIEW.ACTIVATE' | translate }}</span>
        </button>
      </div>
    </div>
  </div>
</div>
